import { normalize } from 'styled-normalize';

const stripFocusRing = <T>(rule: T) =>
  typeof rule === 'string' ? rule.replace(/[^}]*:-moz-focusring[^}]*}/, '') : rule;

export const normalizeWithoutFocusRing = Array.isArray(normalize)
  ? normalize.map(stripFocusRing)
  : stripFocusRing(normalize);
